export enum AccountCheck {
    // Norway: length = 11, Modulus11 function check, no sortcode
    NORWAY = 1,
    // UK: length 7 or 8, sortcode length = 6
    UK = 2,
    // US: length > 7 and < 13, sortcode length = 9
    US = 3,

    ES = 4
}
